<template>
  <div class="home-content-page-v">
    <content-title title="资料下载"></content-title>
    <div class="output-content">
      <!-- <div class="output-content-1">
        <div class="checkbox-content">
          <span>数据下载</span>
          <a href="javascript:;" class="checkbox-one">
            <img src="~assets/checked-2.png" alt="" v-if="down1" @click="down1=false">
            <img src="~assets/unchecked-2.png" alt="" v-if="!down1" @click="down1=true">
            <div class="checkbox-label">
              演示数据下载 <a v-if="down1" :href="down1 ? '/static/演示数据.xlsx' : ''" class="output-btn" download="演示数据">导出到Excel</a>
            </div>
          </a>
        </div>
      </div>
      <div class="m-line">
      </div> -->
      <div class="output-content-1">
        <div class="checkbox-content">
          <span>文档下载</span>
          <a href="javascript:;" class="checkbox-one" @click="down3=down2;down2=!down2;">
            <img src="~assets/checked-2.png" alt="" v-if="down2">
            <img src="~assets/unchecked-2.png" alt="" v-if="!down2">
            <div class="checkbox-label">
              简洁版VPR介绍资料
            </div>
          </a>
          <a href="javascript:;" class="checkbox-one" @click="down2=down3;down3=!down3">
            <img src="~assets/checked-2.png" alt="" v-if="down3">
            <img src="~assets/unchecked-2.png" alt="" v-if="!down3">
            <div class="checkbox-label">
              详细版VPR介绍资料
            </div>
          </a>
          <a :href="down2 ? '/static/问题介绍简洁版.pdf' : '/static/问题介绍详细版.pdf'" :download="down2 ? '问题介绍简洁版.pdf' : '问题介绍详细版.pdf'" class="output-btn btm-btn" v-if="login === 1">下载文档</a>
          <a @click="goLgin" class="output-btn btm-btn" v-else>下载文档</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ContentTitle from '../components_bit/ContentTitle'
  export default {
    components: {
      ContentTitle
    },
    data () {
      return {
        down2: false,
        down3: false
      }
    },
    computed: {
      login: {
        get () {
          return this.$store.getters.login
        }
      }
    },
    methods: {
      goLgin () {
        this.$router.push('/login')
        this.$store.dispatch('setLoginFor', '/down')
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../style/base.less';
  .output-btn {
    color:#fff;
    background-color: @bak-color-2;
    padding: 0.5em 1.5em;
    text-align: center;
    border-radius: 0.3em;
    letter-spacing: 0.1em;
  }
  .output-content {
    .content-shadow;
    .content-bottom-radius;
    display: flex;
    background-color: #fff;
  }
  .checkbox-label {
    .output-btn {
      margin-left: 3em;
    }
  }
  .btm-btn {
    margin: 1em 0 0 2em;
  }
  .m-line {
    width: 2px;
    height: 15em;
    background-color: #ccc;
    margin: 1.5em 2.2em 0 0;
  }
  .output-content-1 {
    flex: 1;
    margin: 1em 2.5em 7em;
    display: flex;

  }
  .checkbox-content {
    display: flex;
    flex-direction: column;
    span {
      line-height: 1;
      font-size: 1.13em;
      padding-bottom: 0.5em;
      color: @bak-color-2;
    }
  }
  .checkbox-one {
    display: flex;
    align-items: center;
    height: 3.4em;
    font-size: 1em;
    color:@bak-color-1;
    img {
      padding-right: 1em;
    }
  }
</style>



// WEBPACK FOOTER //
// down.vue?173521d4